export class CustomError extends Error {
    statusCode: number;

    constructor(message: unknown, statusCode = 400) {
        super(typeof message === 'object' ? JSON.stringify(message) : String(message));
        this.statusCode = statusCode;
    }
}
